import Image from 'next/image';
import React from 'react';

const IntegrationsTech = () => {
    return (
        <div className="section-py !pt-0 !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-4 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Integrations & Tech Stack
                        </h2>
                        <p className='mb-0' data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our Conversational AI & RAG solutions are built on a modular, open, and scalable technology
                            architecture that adapts easily to any enterprise IT ecosystem. We integrate seamlessly with the
                            best-of-breed LLM APIs, open-source models, and high-performance vector databases to deliver robust,
                            production-ready systems
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_llmprovider.svg"
                                width={36}
                                height={36}
                                alt="LLM Providers & Models"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">LLM Providers & Models</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            We work with leading models and APIs, including OpenAI (GPT-4, ChatGPT series) and Anthropic (Claude
                            series) for cutting-edge conversational capabilities. We also leverage powerful open-source models
                            from Hugging Face (like Llama and Mistral) for fine-tuning and domain-specific adaptation.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_developmentframework.svg"
                                width={36}
                                height={36}
                                alt="Development Frameworks & Orchestration"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Development Frameworks & Orchestration</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            We use advanced orchestration frameworks like LangChain and LlamaIndex to build complex, agentic
                            workflows, manage conversational flows, and ensure reliable RAG pipelines.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_toptirevector.svg"
                                width={36}
                                height={36}
                                alt="Top-Tier Vector Databases"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Top-Tier Vector Databases</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Our expertise covers the leading vector databases required for high-speed semantic search. We commonly
                            work with Pinecone, Milvus, Weaviate, Chroma, and FAISS, selecting the best option based on your
                            scalability, security, and deployment needs.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/llms-aiml/svg/ic_mlops.svg" width={36} height={36} alt="MLOps & Observability" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">MLOps & Observability</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            We ensure enterprise-grade reliability using tools like LangSmith for tracing and debugging, alongside
                            robust CI/CD and monitoring workflows.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/llms-aiml/svg/ic_proprietarygovernance.svg"
                                width={36}
                                height={36}
                                alt="Proprietary Governance Layer"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Proprietary Governance Layer</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            We use advanced orchestration frameworks like LangChain and LlamaIndex to build complex, agentic
                            workflows, manage conversational flows, and ensure reliable RAG pipelines.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntegrationsTech;
